import * as React from "react";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import classes from "../Styles/ReadyToSellByCarrier.module.css";

const RTSByCarrierNotRTSCard = (props) => {
  const { id, agencyReadyToSellByCarrier, agentsNotReadyToSell } = props;

  const filteredAgentsNotReadyToSell = agentsNotReadyToSell.filter(
    (records) => records.carrierId === id
  );

  const filteredData = agencyReadyToSellByCarrier.filter(
    (records) => records.carrierId === id && records.isReady === "false"
  );
  const getName = () => {
    const data = agencyReadyToSellByCarrier.filter(
      (records) => records.carrierId === id
    );
    return data[0]?.carrierName;
  };
  const getCount = () => {
    let results = 0;
    if (filteredData.length > 0) {
      let results = 0;
      if (filteredData.length > 0) {
        results = filteredData[0].totalByReadyStatus;
      } else {
        results = 0;
      }
      return results;
    } else {
      return results;
    }
  };
  const name = getName();
  const count = getCount();

  const handleDownload = () => {
    // Helper to escape CSV values
    const escapeCSV = (value) => `"${String(value).replace(/"/g, '""')}"`;

    const report = [
      ["Carrier", "Agent Name", "Email"],
      ...filteredAgentsNotReadyToSell.map((record) => [
        record.carrierName,
        record.agentName,
        record.email,
      ]),
    ]
      .map((row) => row.map(escapeCSV).join(","))
      .join("\n");
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + report], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${getName()}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Box sx={{ minWidth: 275, margin: 1 }}>
      <Card className={classes.gridItem} sx={{ maxWidth: 225 }}>
        <CardHeader
          avatar={
            <Avatar
              sx={{
                bgcolor: "rgb(255, 187, 0)",
              }}
              aria-label="carrier"
            >
              <NewReleasesIcon />
            </Avatar>
          }
          title={name}
          subheader={`Not Ready to Sell: ${count}`}
        />
        <CardActions
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "auto",
          }}
        >
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleDownload}
            disabled={count === 0}
          >
            Download
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default RTSByCarrierNotRTSCard;
